export const answerDiffsFieldsLabel = [
    {
        name: "description",
        label: "Description courte",
        type: "textarea",
        tab: 'general-tab',
    },
    {
        name: "description_long",
        label: "Description longue",
        type: "textarea",
        tab: 'general-tab',
    },
    {
        name: "Langue",
        label: "Langues parlées",
        type: "select",
        tab: 'general-tab',
    },
    {
        name: "media",
        label: "Multimedias",
        type: "image",
        tab: 'media-tab',
    },
    {
        name: "name",
        label: "Nom de l'activité",
        type: "text",
        tab: 'general-tab',
    },
    {
        name: "address",
        label: "Adresse",
        type: "text",
        tab: 'localisation-tab',
    },
    {
        name: "opening_period",
        label: "Périodes d'ouverture",
        type: "opening",
        tab: 'opening-period-tab',
    },
    {
        name: "contact",
        label: "Contacts",
        type: "contactBloc",
        tab: 'contacts-tab',
    },
    {
        name: "commune_id",
        label: "Ville",
        type: "select",
        tab: 'localisation-tab',
    },
    {
        name: "postal_code",
        label: "Code postal",
        type: "text",
        tab: 'localisation-tab',
    },
    {
        name: "QuebecLabels",
        label: "Labels",
        type: "select",
        tab: 'specific-tab',
    },
    {
        name: "description_2025_innovation",
        label: "Nouveautés 2025",
        type: "textarea",
        tab: 'general-tab',
    },
    {
        name: "pricing_complement",
        label: "Complément tarifaire",
        type: "textarea",
        tab: 'price-period-tab',
    },
    {
        name: "phone",
        label: "Téléphone",
        type: "phonesOrEmails",
        tab: 'contact-tab',
    },
    {
        name: "email",
        label: "Email",
        type: "phonesOrEmails",
        tab: 'contact-tab',
    },
    {
        name: "website",
        label: "Site internet",
        type: "text",
        tab: 'platform-tab',
    },
    {
        name: "tripadvisor",
        label: "Tripadvisor",
        type: "text",
        tab: 'platform-tab',
    },
    {
        name: "yelp",
        label: "Yelp",
        type: "text",
        tab: 'platform-tab',
    },
    {
        name: "facebook",
        label: "Facebook",
        type: "text",
        tab: 'platform-tab',
    },
    {
        name: "google",
        label: "Google",
        type: "text",
        tab: 'platform-tab',
    },
    {
        name: "youtube",
        label: "Youtube",
        type: "text",
        tab: 'platform-tab',
    },
    {
        name: "instagram",
        label: "Instagram",
        type: "text",
        tab: 'platform-tab',
    },
    {
        name: "linkedin",
        label: "Linkedin",
        type: "text",
        tab: 'platform-tab',
    },
    {
        name: "twitter",
        label: "X",
        type: "text",
        tab: 'platform-tab',
    },
    {
        name: "tiktok",
        label: "Tiktok",
        type: "text",
        tab: 'platform-tab',
    },
    {
        name: "price_period",
        label: "Périodes tarifaire",
        type: "prices",
        tab: 'price-period-tab',
    },
    {
        name: "booking_link",
        label: "Lien de réservation",
        type: "text",
        tab: 'price-period-tab',
    },
    {
        name: "ModePaiement",
        label: "Moyens de paiement acceptés",
        type: "select",
        tab: 'general-tab',
    },
    {
        name: "citq_number",
        label: "Numéro CITQ",
        type: "text",
        tab: 'specific-tab',
    },
    {
        name: "PrestationEquipement",
        label: "Prestations équipements",
        type: "select",
        tab: 'specific-tab',
    },
    {
        name: "PrestationConfort",
        label: "Prestations de confort",
        type: "select",
        tab: 'specific-tab',
    },
    {
        name: "PrestationService",
        label: "Prestations services",
        type: "select",
        tab: 'specific-tab',
    },
    {
        name: "gps",
        label: "Coordonnées GPS",
        type: "map",
        tab: 'localisation-tab',
    },
    {
        name: "IndicationTarif",
        label: "Indication tarif",
        type: "select",
        tab: 'price-period-tab',
    },
]